import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs, PageTabsStatus } from "shared/components/layout/PageTabs";
import { useFeatureFlagsActive } from "shared/hooks/useFeatureFlag";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const FundFamilySetupEntitiesPage: React.FC = () => {
  const { t } = useTranslation(["entity", "common"]);
  const { fundFamilyId } = useRequiredStringParams();

  const featureFlags = useFeatureFlagsActive([
    "allow_creation_of_allocation_rule_graphs_via_ui",
    "use_allocation_rule_groups",
  ]);

  const isEitherFlagOn = useMemo(
    () =>
      featureFlags.get("allow_creation_of_allocation_rule_graphs_via_ui") ||
      featureFlags.get("use_allocation_rule_groups"),
    [featureFlags],
  );

  const hiddenTabs: PageTabsStatus = {
    fundFamilySetupEntitiesAllocationsList: isEitherFlagOn,
  };

  return (
    <PageContent isFullHeight={true}>
      <PageHeader title={t("common:entities")} />
      <PageTabs context={{ fundFamilyId }} hiddenTabs={hiddenTabs} />
    </PageContent>
  );
};
